import apiClient from '../index'

const rotationRuleBasePath = 'roster/rotation-rules'

export const getRotationRules = (params) =>
  apiClient.get(rotationRuleBasePath, {
    params,
  })

export const getRotationRuleMeta = () => apiClient.get(`${rotationRuleBasePath}/meta`)

export const getRotationRuleById = (id) => apiClient.get(`${rotationRuleBasePath}/${id}`)

export const createRotationRule = (data) => apiClient.post(rotationRuleBasePath, data)

export const updateRotationRule = (id, data) => apiClient.put(`${rotationRuleBasePath}/${id}`, data)

export const updateRotationRuleStatus = (id, data) =>
  apiClient.patch(`${rotationRuleBasePath}/${id}/status`, data)
